module.exports = __webpack_public_path__ + "img/reference1.12715bbc.png";